export enum AttachmentOptionsEnum {
  EOB = 'EOB',
  MEDICAL_RECORD = 'MEDICAL_RECORD',
  OPERATIVE_NOTES = 'OPERATIVE_NOTES',
  MEMBER_CONSENT = 'MEMBER_CONSENT',
  ITEMIZED_BILLS = 'ITEMIZED_BILLS',
  SUPPORTING_DOCS = 'SUPPORTING_DOCS',
  EMAIL_FAX_PAGE = 'EMAIL_FAX_PAGE'
}
